import RequestAbstract from "../abstract";

export default class CryptoCoins extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/crypto-coins';
    }

}
